import React from 'react';
import TeamMemberReveal from '../Team/TeamMemberReveal';

const Home = () => {
  return (
    <main className="min-h-screen">
      <TeamMemberReveal />
    </main>
  );
};

export default Home;

